export default __webpack_public_path__ + "media/images/images/carousel/26-7e5707dc314a54d263a15cd281a9ab96.jpg";